import React from 'react';
import './AboutVenueDetails.css';

export default function AboutVenueDetails() {
  return (
    <div className="venue-about-container">
      <h1 className="venue-heading">About The Grand Sapphire Hall</h1>
      
      <p className="venue-description">
        The Grand Sapphire Hall is a premier event venue located in the heart of Delhi. Known for its luxurious interiors,
        elegant ambiance, and top-notch services, it is the perfect location for weddings, corporate events, receptions,
        and social gatherings.
      </p>

      <div className="venue-section">
        <h2>Highlights</h2>
        <ul>
          <li>Capacity: Up to 500 guests</li>
          <li>Valet Parking Available</li>
          <li>In-house Catering & DJ</li>
          <li>Dedicated Bridal Room</li>
          <li>Air Conditioned Banquet Halls</li>
        </ul>
      </div>

      <div className="venue-section">
        <h2>Venue Features</h2>
        <div className="venue-features">
          <span className="feature-tag">Stage Setup</span>
          <span className="feature-tag">LED Screens</span>
          <span className="feature-tag">Lawn + Indoor Halls</span>
          <span className="feature-tag">Custom Decor</span>
          <span className="feature-tag">Live Counters</span>
        </div>
      </div>

      <div className="venue-section">
        <h2>Contact Information</h2>
        <p>📍 Address: 123 MG Road, Near City Center, New Delhi</p>
        <p>📞 Phone: +91 9876543210</p>
        <p>📧 Email: info@grandsapphirehall.com</p>
      </div>

      <div className="venue-section">
        <h2>Client Testimonials</h2>
        <blockquote>
          "An absolutely stunning venue! Our wedding was magical and everything was perfectly managed. Highly recommended."
        </blockquote>
        <p className="testimonial-author">- Riya & Akash</p>
      </div>
    </div>
  );
}
